module.exports = "<div class=\"container\">\r\n  <mat-card [class.custom-color]=\"buttonActive\" ngClass.lt-md=\"custom-height-mobile\">\r\n    <div fxLayout.gt-xs=\"row\" fxLayout.lt-md=\"column\" fxLayoutAlign=\"center center\" fxLayoutGap.gt-xs=\"10px\" fxLayoutGap.lt-md=\"4px\">\r\n      <div><mat-icon>{{buttonIcon}}</mat-icon></div>\r\n      <div>{{buttonString}}</div></div>\r\n  </mat-card>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/generic-form-buttons/generic-form-buttons.component.html
// module id = ./src/app/widgets/generic-form-buttons/generic-form-buttons.component.html
// module chunks = main